/* eslint-disable lines-between-class-members */

import date from 'quasar/src/utils/date.js';;
import { constants } from '../constants';
import { translateDescription, translateShortDescription, translateTitle } from '../language';

class LocationModel {
  constructor(data) {
    this.id = data.id;
    this.uuid = data.uuid;
    this.codename = data.codename;
    this.title = data.title;
    this.titleEN = data.titleEN;
    this.shortDescription = data.shortDescription;
    this.shortDescriptionEN = data.shortDescriptionEN;
    this.description = data.description;
    this.descriptionEN = data.descriptionEN;
    this.phone = data.phone;
    this.longitude = data.longitude;
    this.latitude = data.latitude;
    this.categoryId = data.categoryId;
    this.waitingTimes = data.waitingTimes;
    this.images = data.images;
    this.openingHours = data.openingHours;
    this.deliveryMethods = data.deliveryMethods;
    this.active = data.active;
    this.closed = data.closed;
    this.closedReason = data.closedReason;
  }

  getTitle() {
    return translateTitle(this);
  }

  getShortDescription() {
    return translateShortDescription(this);
  }

  getDescription() {
    return translateDescription(this);
  }

  hasImages() {
    return this.images && this.images.length > 0;
  }

  setProtocol(url) {
    const protocol = process.env.RELEASE === 'production' ? 'https://' : 'http://';
    if (url && url.indexOf('//') === 0) {
      return url.replace('//', protocol);
    }

    return url;
  }

  getCoverImage() {
    const image = {
      src: null,
      srcset: '',
    };

    const sizes = [];

    if (this.images && this.images.length > 0) {
      const coverImage = this.images[0];
      image.src = this.setProtocol(coverImage.sizes.original);

      if (coverImage.sizes.xs) {
        image.srcset += `${this.setProtocol(coverImage.sizes.xs)} 600w,`;
        sizes.push('(max-width: 600px) 600px');
      }
      if (coverImage.sizes.sm) {
        image.srcset += `${this.setProtocol(coverImage.sizes.sm)} 1024w,`;
        sizes.push('(max-width: 1024px) 1024px');
      }
      if (coverImage.sizes.md) {
        image.srcset += `${this.setProtocol(coverImage.sizes.md)} 1440w,`;
        sizes.push('(max-width: 1440px) 1440px');
      }
      if (coverImage.sizes.lg) {
        image.srcset += `${this.setProtocol(coverImage.sizes.lg)} 1920w,`;
        sizes.push('1920px');
      }

      if (sizes.length > 0) {
        image.sizes = sizes.join(',');
      }
    }

    return image;
  }

  getWaitingTime(deliveryMethodId) {
    if (this.waitingTimes) {
      const waitingTime = this.waitingTimes.find((w) => w.deliveryMethodId === deliveryMethodId);
      if (waitingTime && waitingTime.minutes) {
        return waitingTime.minutes;
      }
    }

    return false;
  }

  isOpen(deliveryMethodId) {
    if (this.closed) {
      return false;
    }
    let isOpen = false;
    const preferredDeliveryMethodId = (deliveryMethodId) || constants.DEFAULT_DELIVERY_METHOD;

    if (this.openingHours.length > 0) {
      const now = new Date();
      // api 1-7 mon - sun | javascript 0-6 sun-sat
      const today = now.getDay() === 0 ? 7 : now.getDay();
      const time = (now.getHours() * 60) + now.getMinutes();

      const openingHours = this.openingHours.find(
        (entry) => entry.deliveryMethodId === preferredDeliveryMethodId,
      );

      if (!openingHours) {
        return false;
      }

      openingHours.days.forEach((day) => {
        if (day.day === today) {
          if (time > day.start && time < day.end) {
            isOpen = true;
          }
        }
      });
    }

    return isOpen;
  }

  getOpeningHoursToday(deliveryMethodId) {
    const now = new Date();
    const today = now.getDay() === 0 ? 7 : now.getDay();
    const time = (now.getHours() * 60) + now.getMinutes();

    const openingHours = this.openingHours.filter((oh) => oh.deliveryMethodId === deliveryMethodId);
    if (openingHours.length > 0) {
      const days = openingHours[0].days.filter((day) => day.day === today);
      return days.find((day) => day.end > time);
    }

    return null;
  }

  getOpeningHoursString(deliveryMethodId) {
    const preferredDeliveryMethodId = (deliveryMethodId) || constants.DEFAULT_DELIVERY_METHOD;
    const openingHours = this.getOpeningHoursToday(preferredDeliveryMethodId);
    if (!openingHours) {
      return '';
    }

    const open = new Date();
    open.setTime(openingHours.start * 60 * 1000);
    const close = new Date();
    close.setTime(openingHours.end * 60 * 1000);

    return `${date.formatDate(open, 'H:mm')} - ${date.formatDate(close, 'H:mm')}`;
  }
}

export default LocationModel;
